function toggleFilter() {
  const body = document.getElementById("filterBody");

  if (!body) return;

  body.style.display =
    body.style.display === "none"
      ? "block"
      : "none";
}


/* FILTER SYSTEM */

document.addEventListener("DOMContentLoaded", function () {

  const container =
    document.getElementById("filterBody");

  if (!container) return;

  container.addEventListener(
    "change",
    function (e) {

      const target = e.target;

      if (target.id === "clearAllFilters") {

        const url =
          new URL(window.location.href);

        url.search = "";

        applyFilters(url.toString());

        container
          .querySelectorAll("input")
          .forEach(input => {

            input.checked = false;

          });

        target.checked = true;

        return;

      }

      if (
        target.classList.contains(
          "price-filter"
        )
      ) {

        const url =
          new URL(window.location.href);

        container
          .querySelectorAll(
            ".price-filter"
          )
          .forEach(cb => {

            cb.checked = false;

          });

        target.checked = true;

        url.searchParams.set(
          "filter.v.price.lte",
          target.dataset.price
        );

        applyFilters(url.toString());

        return;

      }

      if (target.dataset.url) {

        applyFilters(
          target.dataset.url
        );

      }

    }
  );

});


/* FILTER STATE FIX */

document.addEventListener(
"DOMContentLoaded",
function(){

const container =
document.getElementById(
"filterBody"
);

const clearAll =
document.getElementById(
"clearAllFilters"
);

if(
!container
||
!clearAll
) return;

const anyChecked =
container.querySelectorAll(
"input:checked"
).length > 0;

if(!anyChecked){

clearAll.checked=true;

}

}
);


/* FILTER AJAX */

function applyFilters(url){

const loader=
document.getElementById(
"filterLoader"
);

if(loader){

loader.classList.remove(
"hidden"
);

}

fetch(url)

.then(res=>res.text())

.then(html=>{

const doc=
new DOMParser()
.parseFromString(
html,
"text/html"
);

const newGrid=

doc.querySelector(
"#ProductGridContainer"
)

||

doc.querySelector(
"#product-grid"
)

||

doc.querySelector(
".product-grid"
);

const currentGrid=

document.querySelector(
"#ProductGridContainer"
)

||

document.querySelector(
"#product-grid"
)

||

document.querySelector(
".product-grid"
);

if(
newGrid
&&
currentGrid
){

currentGrid.innerHTML=
newGrid.innerHTML;

}

window.history.pushState(
{},
"",
url
);

})

.catch(err=>{

console.error(
"Filter error:",
err
);

})

.finally(()=>{

if(loader){

loader.classList.add(
"hidden"
);

}

});

}


/* HEADER FIX */

document.addEventListener(
"DOMContentLoaded",
function(){

const header=
document.querySelector(
".facets-container"
);

const whatsapp=
document.querySelector(
".wsp-whatsapp"
);

const footer=
document.querySelector(
".shopify-section-group-footer-group"
);

if(!header) return;

let footerVisible=false;

function updateHeader(){

if(!header) return;

if(footerVisible){

header.classList.remove(
"filter-active"
);

header.classList.add(
"hidden-filter"
);

return;

}

header.classList.remove(
"hidden-filter"
);

if(window.scrollY>10){

header.classList.add(
"filter-active"
);

whatsapp?.classList.add(
"active"
);

}else{

header.classList.remove(
"filter-active"
);

whatsapp?.classList.remove(
"active"
);

}

}

if(footer){

const observer=
new IntersectionObserver(

([entry])=>{

footerVisible=
entry.isIntersecting;

updateHeader();

},

{

root:null,
threshold:0.1

}

);

observer.observe(
footer
);

}

window.addEventListener(
"scroll",
updateHeader
);

updateHeader();

}
);


/* MOBILE CLEAR */

document.addEventListener(
"DOMContentLoaded",
function(){

const removeBtn=
document.querySelector(
".mobile-facets__clear-wrapper"
);

const form=
document.querySelector(
"#FacetFiltersFormMobile"
);

if(
!removeBtn
||
!form
) return;

removeBtn.addEventListener(
"click",
function(e){

e.preventDefault();

form.reset();

document
.querySelectorAll(
'.facets-wrap input[type="checkbox"]'
)
.forEach(cb=>{

cb.checked=false;

});

});

}
);


/* MOBILE DRAWER */

document.addEventListener(
"DOMContentLoaded",
function(){

const closeBtn=
document.querySelector(
".cross-btn-filter"
);

if(!closeBtn) return;

closeBtn.addEventListener(
"click",
function(){

const drawer=
document.querySelector(
".mobile-facets__disclosure"
);

if(!drawer) return;

const summary=
drawer.querySelector(
".mobile-facets__open-wrapper"
);

drawer.removeAttribute(
"open"
);

drawer.classList.remove(
"menu-opening"
);

summary?.setAttribute(
"aria-expanded",
"false"
);

});

}
);


/* BODY LOCK */

document.addEventListener(
"DOMContentLoaded",
()=>{

const disclosure=
document.querySelector(
".mobile-facets__disclosure"
);

if(!disclosure) return;

function toggleScroll(){

document.body.style.overflow=

disclosure.hasAttribute(
"open"
)

?

"hidden"

:

"";

}

toggleScroll();

new MutationObserver(
toggleScroll
)

.observe(

disclosure,

{

attributes:true,
attributeFilter:["open"]

}

);

}
);


/* FILTER PILL ACTIVE */

document.addEventListener(
"DOMContentLoaded",
function(){

document
.querySelectorAll(
".pill input"
)

.forEach(input=>{

input.addEventListener(
"change",
function(){

const label=
this.closest(
".pill"
);

if(!label)return;

label.classList.toggle(
"active",
this.checked
);

});

});

}
);